var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfrastructure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke-linejoin:round;}.cls-2,.cls-3{stroke:#274353;stroke-linecap:round;stroke-width:1.1px;}.cls-3{fill:#9bd2fa;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -130,
    y: -116.25,
    width: 310,
    height: 232.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -130,
    y: -116.25,
    width: 310,
    height: 232.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.44,
    y: 25.53,
    width: 17.01,
    height: 1.55,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.44,
    y: 16.8,
    width: 17.01,
    height: 1.56,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.94,
    y1: 34.24,
    x2: 22.94,
    y2: 35.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.98,
    y1: 38.21,
    x2: 20.43,
    y2: 38.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.36,
    y1: 38.21,
    x2: 33.81,
    y2: 38.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.36,38.28a2.42,2.42,0,1,0-2.42,2.42A2.42,2.42,0,0,0,25.36,38.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,27.08H12.86a.48.48,0,0,0-.48.49v6.18a.48.48,0,0,0,.48.49H33a.49.49,0,0,0,.49-.49V27.57A.49.49,0,0,0,33,27.08Zm-3.37,5A1.39,1.39,0,1,1,31,30.73,1.39,1.39,0,0,1,29.65,32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,18.35H12.86a.48.48,0,0,0-.48.49V25a.48.48,0,0,0,.48.49H33a.49.49,0,0,0,.49-.49V18.84A.49.49,0,0,0,33,18.35Zm-3.37,4.94A1.4,1.4,0,1,1,31,21.9,1.39,1.39,0,0,1,29.65,23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,9.63H12.86a.48.48,0,0,0-.48.49V16.3a.48.48,0,0,0,.48.49H33a.49.49,0,0,0,.49-.49V10.12A.49.49,0,0,0,33,9.63Zm-3.37,5A1.4,1.4,0,1,1,31,13.21,1.39,1.39,0,0,1,29.65,14.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.06,
    y: 13.12,
    width: 0.35,
    height: 0.35,
    transform: "translate(38.48 26.59) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.66,
    y: 13.12,
    width: 0.35,
    height: 0.35,
    transform: "translate(31.67 26.59) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.06,
    y: 21.81,
    width: 0.35,
    height: 0.35,
    transform: "translate(38.48 43.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.66,
    y: 21.81,
    width: 0.35,
    height: 0.35,
    transform: "translate(31.67 43.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.06,
    y: 30.69,
    width: 0.35,
    height: 0.35,
    transform: "translate(38.48 61.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.66,
    y: 30.69,
    width: 0.35,
    height: 0.35,
    transform: "translate(31.67 61.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.44,
    y: 25.53,
    width: 17.01,
    height: 1.55,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.44,
    y: 16.8,
    width: 17.01,
    height: 1.56,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.94,
    y1: 34.24,
    x2: 22.94,
    y2: 35.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.98,
    y1: 38.21,
    x2: 20.43,
    y2: 38.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.36,
    y1: 38.21,
    x2: 33.81,
    y2: 38.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.36,38.28a2.42,2.42,0,1,0-2.42,2.42A2.42,2.42,0,0,0,25.36,38.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,27.08H12.86a.48.48,0,0,0-.48.49v6.18a.48.48,0,0,0,.48.49H33a.49.49,0,0,0,.49-.49V27.57A.49.49,0,0,0,33,27.08Zm-3.37,5A1.39,1.39,0,1,1,31,30.73,1.39,1.39,0,0,1,29.65,32.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,18.35H12.86a.48.48,0,0,0-.48.49V25a.48.48,0,0,0,.48.49H33a.49.49,0,0,0,.49-.49V18.84A.49.49,0,0,0,33,18.35Zm-3.37,4.94A1.4,1.4,0,1,1,31,21.9,1.39,1.39,0,0,1,29.65,23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,9.63H12.86a.48.48,0,0,0-.48.49V16.3a.48.48,0,0,0,.48.49H33a.49.49,0,0,0,.49-.49V10.12A.49.49,0,0,0,33,9.63Zm-3.37,5A1.4,1.4,0,1,1,31,13.21,1.39,1.39,0,0,1,29.65,14.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.06,
    y: 13.12,
    width: 0.35,
    height: 0.35,
    transform: "translate(38.48 26.59) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.66,
    y: 13.12,
    width: 0.35,
    height: 0.35,
    transform: "translate(31.67 26.59) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.06,
    y: 21.81,
    width: 0.35,
    height: 0.35,
    transform: "translate(38.48 43.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.66,
    y: 21.81,
    width: 0.35,
    height: 0.35,
    transform: "translate(31.67 43.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.06,
    y: 30.69,
    width: 0.35,
    height: 0.35,
    transform: "translate(38.48 61.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.66,
    y: 30.69,
    width: 0.35,
    height: 0.35,
    transform: "translate(31.67 61.73) rotate(180)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/infrastructure.c9b2458ff511a4916b1641bf09382e85.svg";
export { ForwardRef as ReactComponent };